var _excluded = ["children"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable max-len */
import React, { createContext, useContext } from 'react';
import { useDTRP } from '.';
var DtrpContext = /*#__PURE__*/createContext(null);
export var DtrpContextProvider = _ref => {
  var {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var value = useDTRP(props);
  return /*#__PURE__*/React.createElement(DtrpContext.Provider, {
    value: value
  }, children);
};
export var useDrtpContext = () => {
  var cxt = useContext(DtrpContext);
  if (!cxt) throw new Error('kurtesy warning');
  return cxt;
};
//# sourceMappingURL=ContextProvider.js.map